<span *ngIf="saving" class="btn btn-ghost-secondary disabled autosave-status" role="status" aria-live="polite">
  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
  <span>{{ label }}</span>
</span>
